/* eslint-disable react/no-unknown-property */
/* eslint-disable no-useless-escape */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import Footer from "../Components/Footer";
import Cookies from "js-cookie";

import "../Styles/ofislerimiz.css";
import {
  XCircle,
  User,
  Mail,
  CreditCard,
  Calendar,
  Home,
  RefreshCw,
  Phone,
  AlertTriangle,
} from "lucide-react";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    let params = useParams();
    let [searchParams] = useSearchParams();
    return <Component {...props} router={{ navigate, params, searchParams }} />;
  }

  return ComponentWithRouterProp;
}

class PaymentFailed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentData: {
        user: "",
        email: "",
        id: "",
        payment: "",
        amount: "",
        errorCode: "",
        errorMessage: "",
        transactionId: "",
        date: new Date().toLocaleDateString("tr-TR"),
      },
    };
  }

  componentDidMount() {
    const searchParams = this.props.router.searchParams;

  
    const transactionId = searchParams.get("id"); 
    const displayId = searchParams.get("displayId"); 

    this.setState({
      paymentData: {
        user: searchParams.get("user")
          ? decodeURIComponent(searchParams.get("user"))
          : "Kullanıcı",
        email: searchParams.get("email")
          ? decodeURIComponent(searchParams.get("email"))
          : "",
        id: searchParams.get("id") || "",
        payment: searchParams.get("payment") || "failed",
        amount: searchParams.get("amount") || "",
        errorCode:
          searchParams.get("errorCode") ||
          searchParams.get("error") ||
          "ERR_001",
        errorMessage: this.getErrorMessageFromCode(
          searchParams.get("errorCode") ||
            searchParams.get("error") ||
            "ERR_001"
        ),
        transactionId: displayId || transactionId || "", 
        internalTransactionId: transactionId || "", 
        date: new Date().toLocaleDateString("tr-TR"),
      },
    });
  }

  getErrorMessageFromCode = (errorCode) => {
    const errorMessages = {
      ERR_001: "Ödeme işlemi başarısız oldu",
      "payment-failed": "Ödeme işlemi başarısız oldu",
      "server-error": "Sunucu hatası oluştu",
      "missing-order-id": "Sipariş ID'si bulunamadı",
      "user-not-found": "Kullanıcı bilgisi bulunamadı",
      ERR_002: "Kart reddedildi",
      ERR_003: "Yetersiz bakiye",
      ERR_004: "İşlem süresi doldu",
      ERR_005: "Teknik hata oluştu",
    };

    return errorMessages[errorCode] || "Ödeme işlemi başarısız oldu";
  };

  getErrorDetails = (errorCode) => {
    const errorDetails = {
      ERR_001: {
        title: "Genel Ödeme Hatası",
        description: "Ödeme işlemi sırasında beklenmeyen bir hata oluştu.",
        solution:
          "Lütfen tekrar deneyin veya farklı bir ödeme yöntemi kullanın.",
      },
      "payment-failed": {
        title: "Ödeme Başarısız",
        description: "Ödeme işlemi tamamlanamadı.",
        solution: "Kart bilgilerinizi kontrol edin ve tekrar deneyin.",
      },
      "server-error": {
        title: "Sunucu Hatası",
        description: "Sistem geçici olarak kullanılamıyor.",
        solution: "Lütfen birkaç dakika sonra tekrar deneyin.",
      },
      "missing-order-id": {
        title: "Eksik Bilgi",
        description: "İşlem bilgileri eksik.",
        solution: "Lütfen işlemi tekrar başlatın.",
      },
      "user-not-found": {
        title: "Kullanıcı Bulunamadı",
        description: "Kullanıcı bilgileri bulunamadı.",
        solution: "Lütfen kayıt işlemini tekrar yapın.",
      },
      ERR_002: {
        title: "Kart Reddedildi",
        description: "Bankanız tarafından işlem reddedildi.",
        solution:
          "Kart bilgilerinizi kontrol edin veya bankanızla iletişime geçin.",
      },
      ERR_003: {
        title: "Yetersiz Bakiye",
        description: "Kartınızda yetersiz bakiye bulunmaktadır.",
        solution: "Kartınıza yeterli bakiye yükledikten sonra tekrar deneyin.",
      },
      ERR_004: {
        title: "Süre Aşımı",
        description: "İşlem süresi doldu.",
        solution: "Lütfen işlemi tekrar başlatın.",
      },
      ERR_005: {
        title: "Teknik Hata",
        description: "Sistem geçici olarak kullanılamıyor.",
        solution: "Lütfen birkaç dakika sonra tekrar deneyin.",
      },
    };

    return errorDetails[errorCode] || errorDetails["ERR_001"];
  };

  handleGoToHome = () => {
    this.props.router.navigate("/");
  };

  handleTryAgain = () => {
    this.props.router.navigate("/register");
  };

  handleContactSupport = () => {
    this.props.router.navigate("/iletisim");
  };

  render() {
    const { paymentData } = this.state;
    const errorDetails = this.getErrorDetails(paymentData.errorCode);

    return (
      <>
        <Loader />
        <SubHeader />
        <Header
          isLoggedIn={Cookies.get("token") == null ? false : true}
          userName="Mehmet Özkan"
        />

        <div className="offices-container">
          <div
            className="offices-header"
            style={{
              background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)",
            }}
          >
            <div className="offices-header-pattern" />

            <div className="container offices-header-container">
              <div className="row">
                <div className="text-center">
                  <div style={{ marginBottom: "20px" }}>
                    <XCircle size={80} color="white" />
                  </div>
                  <h6 className="offices-header-subtitle">ÖDEME BAŞARISIZ</h6>
                  <h1 className="offices-header-title">
                    Ödeme İşlemi Başarısız!
                  </h1>
                  <p className="offices-header-description">
                    {paymentData.user && paymentData.user !== "Kullanıcı"
                      ? `Sayın ${paymentData.user}, `
                      : ""}
                    üzgünüz ödeme işleminiz tamamlanamadı. Lütfen aşağıdaki
                    bilgileri kontrol edin ve tekrar deneyin.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="offices-grid">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div
                    className="office-card universal-card universal-shimmer"
                    style={{ marginBottom: "40px" }}
                  >
                    <div className="office-card-pattern universal-pattern" />

                    <div
                      className="office-card-content"
                      style={{ padding: "40px" }}
                    >
                      <div
                        className="text-center"
                        style={{ marginBottom: "30px" }}
                      >
                        <div
                          style={{
                            background: "#f44336",
                            borderRadius: "50%",
                            width: "100px",
                            height: "100px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                          }}
                        >
                          <XCircle size={50} color="white" />
                        </div>
                        <h2 style={{ color: "#f44336", marginBottom: "10px" }}>
                          Ödeme Başarısız!
                        </h2>
                        {paymentData.transactionId && (
                          <p style={{ color: "#666", fontSize: "16px" }}>
                            İşlem ID:{" "}
                            <strong>{paymentData.transactionId}</strong>
                          </p>
                        )}
                      </div>

                      <div
                        className="office-warning-card universal-card universal-shimmer"
                        style={{
                          background: "#ffeaa7",
                          border: "1px solid #fdcb6e",
                          marginBottom: "30px",
                        }}
                      >
                        <div
                          className="office-warning-card-content"
                          style={{ padding: "20px" }}
                        >
                          <h4
                            style={{
                              color: "#e17055",
                              marginBottom: "15px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <AlertTriangle
                              size={20}
                              style={{ marginRight: "10px" }}
                            />
                            {errorDetails.title}
                          </h4>
                          <p style={{ color: "#333", marginBottom: "10px" }}>
                            <strong>Hata Kodu:</strong> {paymentData.errorCode}
                          </p>
                          <p style={{ color: "#333", marginBottom: "10px" }}>
                            <strong>Açıklama:</strong>{" "}
                            {errorDetails.description}
                          </p>
                          <p style={{ color: "#333", marginBottom: "0" }}>
                            <strong>Çözüm:</strong> {errorDetails.solution}
                          </p>
                        </div>
                      </div>

                      <div className="row">
                        {paymentData.user &&
                          paymentData.user !== "Kullanıcı" && (
                            <div className="col-md-6">
                              <div
                                className="office-info-card universal-card universal-shimmer"
                                style={{
                                  marginBottom: "20px",
                                  background: "#f8f9fa",
                                }}
                              >
                                <div
                                  className="office-info-card-content"
                                  style={{ padding: "20px" }}
                                >
                                  <h4
                                    style={{
                                      color: "#333",
                                      marginBottom: "15px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <User
                                      size={20}
                                      style={{ marginRight: "10px" }}
                                    />
                                    Kullanıcı Bilgileri
                                  </h4>
                                  <div style={{ marginBottom: "10px" }}>
                                    <strong>Ad Soyad:</strong>{" "}
                                    {paymentData.user}
                                  </div>
                                  {paymentData.email && (
                                    <div
                                      style={{
                                        marginBottom: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Mail
                                        size={16}
                                        style={{ marginRight: "5px" }}
                                      />
                                      <strong>E-posta:</strong>{" "}
                                      {paymentData.email}
                                    </div>
                                  )}
                                  {/* {paymentData.id && (
                                    <div>
                                      <strong>Kullanıcı ID:</strong>{" "}
                                      {paymentData.id}
                                    </div>
                                  )} */}
                                </div>
                              </div>
                            </div>
                          )}

                        <div
                          className={
                            paymentData.user && paymentData.user !== "Kullanıcı"
                              ? "col-md-6"
                              : "col-md-12"
                          }
                        >
                          <div
                            className="office-info-card universal-card universal-shimmer"
                            style={{
                              marginBottom: "20px",
                              background: "#f8f9fa",
                            }}
                          >
                            <div
                              className="office-info-card-content"
                              style={{ padding: "20px" }}
                            >
                              <h4
                                style={{
                                  color: "#333",
                                  marginBottom: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <CreditCard
                                  size={20}
                                  style={{ marginRight: "10px" }}
                                />
                                İşlem Bilgileri
                              </h4>
                              {paymentData.transactionId && (
                                <div style={{ marginBottom: "10px" }}>
                                  <strong>İşlem ID:</strong>{" "}
                                  {paymentData.transactionId}
                                </div>
                              )}
                              <div
                                style={{
                                  marginBottom: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Calendar
                                  size={16}
                                  style={{ marginRight: "5px" }}
                                />
                                <strong>Tarih:</strong> {paymentData.date}
                              </div>
                              <div>
                                <strong>Durum:</strong>
                                <span
                                  style={{
                                    color: "#f44336",
                                    marginLeft: "5px",
                                  }}
                                >
                                  ❌ Başarısız
                                </span>
                              </div>
                              {paymentData.amount && (
                                <div style={{ marginTop: "10px" }}>
                                  <strong>Tutar:</strong> {paymentData.amount}{" "}
                                  TL
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="office-info-card universal-card universal-shimmer"
                        style={{
                          background: "#e3f2fd",
                          border: "1px solid #2196F3",
                          marginBottom: "30px",
                        }}
                      >
                        <div
                          className="office-info-card-content"
                          style={{ padding: "20px" }}
                        >
                          <h4
                            style={{ color: "#1976D2", marginBottom: "15px" }}
                          >
                            💡 Öneriler
                          </h4>
                          <ul
                            style={{
                              color: "#333",
                              marginBottom: "0",
                              paddingLeft: "20px",
                            }}
                          >
                            <li style={{ marginBottom: "8px" }}>
                              Kart bilgilerinizi kontrol edin
                            </li>
                            <li style={{ marginBottom: "8px" }}>
                              İnternet bağlantınızın stabil olduğundan emin olun
                            </li>
                            <li style={{ marginBottom: "8px" }}>
                              Farklı bir ödeme yöntemi deneyin
                            </li>
                            <li style={{ marginBottom: "8px" }}>
                              Problem devam ederse bankayı arayın
                            </li>
                            <li>Destek ekibimizle iletişime geçin</li>
                          </ul>
                        </div>
                      </div>

                      <div className="text-center">
                        <div className="row">
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "15px" }}
                          >
                            <button
                              onClick={this.handleTryAgain}
                              style={{
                                width: "100%",
                                background: "#2196F3",
                                borderColor: "#2196F3",
                                color: "white",
                                border: "none",
                                padding: "15px 30px",
                                borderRadius: "8px",
                                fontSize: "16px",
                                fontWeight: "600",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.background = "#1976D2";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.background = "#2196F3";
                              }}
                            >
                              <RefreshCw
                                size={16}
                                style={{ marginRight: "8px" }}
                              />
                              Tekrar Dene
                            </button>
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "15px" }}
                          >
                            <button
                              onClick={this.handleContactSupport}
                              style={{
                                width: "100%",
                                background: "#ff9800",
                                borderColor: "#ff9800",
                                color: "white",
                                border: "none",
                                padding: "15px 30px",
                                borderRadius: "8px",
                                fontSize: "16px",
                                fontWeight: "600",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.background = "#f57c00";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.background = "#ff9800";
                              }}
                            >
                              <Phone size={16} style={{ marginRight: "8px" }} />
                              Destek
                            </button>
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "15px" }}
                          >
                            <button
                              onClick={this.handleGoToHome}
                              style={{
                                width: "100%",
                                background: "none",
                                border: "2px solid #6c757d",
                                color: "#6c757d",
                                padding: "15px 30px",
                                borderRadius: "8px",
                                fontSize: "16px",
                                fontWeight: "600",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.background = "#6c757d";
                                e.target.style.color = "white";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.background = "none";
                                e.target.style.color = "#6c757d";
                              }}
                            >
                              <Home size={16} style={{ marginRight: "8px" }} />
                              Ana Sayfa
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </>
    );
  }
}

export default withRouter(PaymentFailed);
